import { c as _c } from "react/compiler-runtime";
import { SegmentedControl } from '@onefootprint/ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
type RulesToggleProps = {
  onClick: (isTriggered: boolean) => void;
};
const RulesToggle = t0 => {
  const $ = _c(23);
  const {
    onClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardings.rules.toggle"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const [isTriggeredSelected, setIsTriggeredSelected] = useState(true);
  let t2;
  if ($[1] !== onClick) {
    t2 = isTriggered => {
      setIsTriggeredSelected(isTriggered);
      onClick(isTriggered);
    };
    $[1] = onClick;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleClick = t2;
  let t3;
  if ($[3] !== t) {
    t3 = t(_temp);
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t(_temp2);
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = {
      label: t4,
      value: "triggered"
    };
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t(_temp3);
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = {
      label: t6,
      value: "notTriggered"
    };
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t5 || $[14] !== t7) {
    t8 = [t5, t7];
    $[13] = t5;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const t9 = isTriggeredSelected ? "triggered" : "notTriggered";
  let t10;
  if ($[16] !== handleClick) {
    t10 = value => {
      handleClick(value === "triggered");
    };
    $[16] = handleClick;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t3 || $[20] !== t8 || $[21] !== t9) {
    t11 = <SegmentedControl size="compact" aria-label={t3} options={t8} value={t9} onChange={t10} />;
    $[18] = t10;
    $[19] = t3;
    $[20] = t8;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
};
export default RulesToggle;
function _temp($) {
  return $.ariaLabel;
}
function _temp2($_0) {
  return $_0.triggered;
}
function _temp3($_1) {
  return $_1.notTriggered;
}